import React, { useEffect, useState } from 'react';
import { View, Modal } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import FormActions from '../../../components/FormActions';
import { accessService } from '../../../services/central-api/access';
import MyPhoneInput from '../../../components/MyPhoneInput';
import { WindowInformation } from '../../../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface ModalProps {
    isModalVisible: boolean;
    onClose: () => void;
    installationCompanyId?: number;
}

export default function InstallationCompanyModal({ onClose, installationCompanyId, isModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [name, setName] = useState('');
    const [phone, setPhone] = useState<string>('');

    async function getInstallationCompany(id: number) {
        const installationCompany = await accessService.getInstallationCompany(id);
        setName(installationCompany.name);
        setPhone(installationCompany.phone);
    }

    async function loadPageInfo() {
        try {
            if (installationCompanyId) {
                await getInstallationCompany(installationCompanyId);
            }
        } catch (err) {
            console.error(err);
        }
    }

    function isNameInvalid(value: string) {
        return value == '';
    }

    function isPhoneInvalid(value: string) {
        return value == '' || value.length < 10;
    }

    useEffect(() => {
        if (isModalVisible) {
            loadPageInfo();
        }
    }, [isModalVisible]);

    function isFormValid() {
        return !isNameInvalid(name) && !isPhoneInvalid(phone);
    }

    function clearValues() {
        setName('');
        setPhone('');
    }

    async function formSubmit() {
        try {
            if (installationCompanyId) {
                await accessService.updateInstallationCompany({
                    id: installationCompanyId,
                    name,
                    phone
                });
            } else {
                await accessService.createInstallationCompany({ name, phone });
            }
        } catch (err) {
            console.error(err);
        } finally {
            clearValues();
            onClose();
        }
    }

    return (
        <Modal transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                clearValues();
                onClose();
            }}
        >
            <View style={styles.container}>
                <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: '20%' }]}>
                    <View style={{ rowGap: 10 }}>
                        <FormInput
                            label={translate('name')}
                            placeholder={translate('name')}
                            value={name}
                            onChangeText={setName}
                            invalid={isNameInvalid}
                        />
                        <MyPhoneInput
                            label={translate('phone')}
                            placeholder={translate('phone')}
                            value={phone}
                            onChangeText={setPhone}
                            invalid={isPhoneInvalid}
                        />
                    </View>
                    <FormActions
                        onSubmit={formSubmit}
                        onClose={() => {
                            clearValues();
                            onClose();
                        }}
                        disabled={!isFormValid()} />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minWidth: 300,
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    },
}));
